import React from 'react';
import AdventureBearImage from '@/assets/app/images/common/bottom/adventure-bear.png';
import AppButton from '@/shared/components/ui/new/AppButton';

interface RetryQuizModalProps {
  onConfirm: (isRetry?: boolean) => void;
  onCancel: () => void;
  closeSheet: () => void;
}

export const RetryQuizSheet: React.FC<RetryQuizModalProps> = ({
  onConfirm,
  onCancel,
  closeSheet,
}) => {
  const retryQuiz = () => {
    closeSheet();
    onConfirm(true);
  };
  return (
    <div className="pt-6 pb-2 space-y-6">
      {/* 캐릭터 이미지 */}
      <div className="flex justify-center">
        <img src={AdventureBearImage} />
      </div>

      {/* 메시지 */}
      <h2 className="text-xl font-bold text-[800] text-center m-0" style={{ fontSize: 26 }}>
        모험을 다시 시작합니다.
      </h2>
      <div className="text-center" style={{ color: '#6C6C6C', fontSize: 16 }}>
        알아두세요!
        <br />
        다시 도전한 챕터의 채점결과는
        <br />
        변경되지 않아요.
      </div>

      <div className="button-group" style={{ marginTop: 20 }}>
        <AppButton onConfirm={retryQuiz} message="다시 하기" />
        <AppButton
          backgroundColor="#D4D4D4"
          boxShadowColor="#B7B7B7"
          style={{
            marginTop: 10,
          }}
          onConfirm={onCancel}
          message="모험 종료"
        />
      </div>
    </div>
  );
};
